import { createSlice } from '@reduxjs/toolkit'
import TokenService from 'services/token.service'

import { RootState } from '..'

type InitialState = {
  access: string | null
  refresh: string | null
  isLoggedIn: boolean
}

const initialState: InitialState = {
  access: TokenService.getAccessToken(),
  refresh: TokenService.getRefreshToken(),
  isLoggedIn: !!TokenService.getAccessToken()
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setIsLoggedIn: (state, { payload }: { payload: boolean }) => {
      state.isLoggedIn = payload
    },
    setAuthData: (state, { payload }: { payload: { access: string; refresh: string } }) => {
      state.access = payload.access
      state.refresh = payload.refresh
    },

    logout: () => {
      return initialState
    }
  }
})

export const { setAuthData, setIsLoggedIn, logout } = authSlice.actions

export const isLoggedInSelector = (state: RootState) => state.auth.isLoggedIn

export default authSlice.reducer
